import { WifiOff, RefreshCw } from 'lucide-react';
import { useOfflineDetection } from '@/hooks/useOfflineDetection';
import { useSyncQueue } from '@/hooks/useSyncQueue';
import { useTranslation } from 'react-i18next';

export const OfflineIndicator = () => {
  const { t } = useTranslation();
  const { isOffline } = useOfflineDetection();
  const { isSyncing, pendingCount } = useSyncQueue();

  if (!isOffline && !isSyncing && pendingCount === 0) return null;

  return (
    <div className={`fixed top-0 left-0 right-0 z-50 py-2 px-4 text-center text-sm font-medium ${
      isOffline 
        ? 'bg-amber-500 text-amber-950' 
        : isSyncing 
          ? 'bg-blue-500 text-white'
          : 'bg-amber-100 text-amber-800'
    }`}>
      <div className="container mx-auto flex items-center justify-center gap-2">
        {isOffline ? (
          <>
            <WifiOff className="w-4 h-4" />
            <span>{t('offline.offlineMode')}</span>
          </>
        ) : isSyncing ? (
          <>
            <RefreshCw className="w-4 h-4 animate-spin" />
            <span>{t('offline.syncing')}</span>
          </>
        ) : (
          <>
            <RefreshCw className="w-4 h-4" />
            <span>{t('offline.pendingChanges', { count: pendingCount })}</span>
          </>
        )}
      </div>
    </div>
  );
};
